<template>
    <div>
        <b-spinner variant="primary"
            class="spinStyle"
            v-show="showSpin"
            label="Text Centered"></b-spinner>
        <b-row style="margin-top:10px;">
            <b-col lg="12">
                <div class="filterBar">
                    <b-row>
                        <b-col lg="3">
                            <b-input-group>
                                <b-form-input size="sm"
                                    v-model="productSearchValue"
                                    placeholder="输入品名"></b-form-input>
                                <b-input-group-append>
                                    <b-button size="sm"
                                        v-on:click="searchProductByName()">查询</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        <b-col lg="7">
                            <b-button v-b-toggle.sidebar-cate
                                size="sm"
                                variant="info"
                                style="margin-left:10px">
                                分类选择
                                <b-badge variant="info">{{selectedMultiCateList.length}}</b-badge>
                            </b-button>
                            <b-button v-b-toggle.sidebar-brand
                                size="sm"
                                variant="warning"
                                style="margin-left:10px">
                                品牌选择
                                <b-badge variant="warning">{{selectedMultiBrandList.length}}</b-badge>
                            </b-button>
                            <!-- <b-button size="sm"
                                variant="success"
                                style="margin-left:10px"
                                v-on:click="onShowMyfavorite()">我的收藏 <b-badge variant="success">{{myfavoriteList.length}}</b-badge>
                            </b-button> -->
                            <b-button size="sm"
                                style="margin-left:10px"
                                v-on:click="goToCart()">现售购物车 <b-badge>{{cartItems.length}}</b-badge>
                            </b-button>
                        </b-col>
                    </b-row>
                </div>
                <div class="dataTable">
                    <b-table id="product-table"
                        :fields="productFields"
                        :items="prodcutItems"
                        small
                        bordered
                        hover
                        show-empty
                        empty-text="没有找到匹配的记录"
                        :busy="isTableBusy">
                        <template v-slot:cell(productImg)="row">
                            <b-link :to="{path: '/product/product-detail', query: { productUuid: row.item.productUuid }}"
                                target="_blank">
                                <img :src="row.item.productFinishImageFile.url"
                                    width="30"
                                    height="30">
                            </b-link>
                        </template>
                        <template v-slot:cell(orderQuantity)="row">
                            <b-form-input size="sm"
                                type="number"
                                :step="row.item.productIncreaseStepAmount"
                                v-model="row.item.orderQuantity">
                            </b-form-input>
                        </template>
                        <template v-slot:cell(orderButton)="row">
                            <!-- <a href="#"
                                v-on:click="addOrDelToFavorite(row)">{{myfavoriteList.includes(row.item.productUuid) ? '取消收藏' : '添加收藏'}}</a> / -->
                            <a href="#"
                                v-on:click="addToCart(row.item)">加入购物车</a>
                        </template>
                        <div slot="table-busy"
                            class="text-center text-info my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>加载中...</strong>
                        </div>
                    </b-table>
                </div>
                <div class="pageControl">
                    <b-pagination v-model="feSearch.limit.conditions.pageStart"
                        style="margin-top:20px;"
                        :total-rows="feSearch.limit.conditions.total"
                        :per-page="feSearch.limit.conditions.pageLength"
                        align="center"
                        size="sm"
                        ellipsis-text="..."
                        first-text="首页"
                        prev-text="上一页"
                        next-text="下一页"
                        last-text="尾页"
                        limit="10"
                        @change="onPageChange"></b-pagination>
                </div>
            </b-col>
        </b-row>
        <!-- 分类边栏 -->
        <b-sidebar id="sidebar-cate"
            title="分类选择"
            width="600px"
            shadow>
            <template v-slot:footer="{ hide }">
                <div style="width:100%;text-align:right;padding:10px;">
                    <b-button variant="success"
                        size="sm"
                        @click="confirmMultiCateSearch()">确定</b-button>
                    <b-button variant="warning"
                        size="sm"
                        @click="onResetMultiCate()">重置</b-button>
                    <b-button variant="danger"
                        size="sm"
                        @click="hide">关闭</b-button>
                </div>
            </template>
            <div style="padding:10px;">
                <div style="margin-bottom:10px;"
                    v-for="main in mainCateList"
                    :key="main.mainCategoryUuid">
                    <div style="color:black;font-weight:bold;">{{main.mainCategoryName}}</div>
                    <div>
                        <a href="#"
                            class="sidebar-subcate"
                            v-for="sub in subCateList.filter(e => {return e.subCategoryMainUuid === main.mainCategoryUuid;})"
                            :key="sub.subCategoryUuid"
                            v-bind:class="{ selectcatefont : selectedMultiCateList.includes(sub.subCategoryUuid)}"
                            v-on:click="onSelectMultiCate(sub.subCategoryUuid)">
                            {{sub.subCategoryName}}</a>
                    </div>
                </div>
            </div>
        </b-sidebar>
        <!-- 品牌边栏 -->
        <b-sidebar id="sidebar-brand"
            title="品牌选择"
            width="600px"
            shadow>
            <template v-slot:footer="{ hide }">
                <div style="width:100%;text-align:right;padding:10px;">
                    <b-button variant="success"
                        size="sm"
                        @click="confirmMultiBrandSearch()">确定</b-button>
                    <b-button variant="warning"
                        size="sm"
                        @click="onResetMultiBrand()">重置</b-button>
                    <b-button variant="danger"
                        size="sm"
                        @click="hide">关闭</b-button>
                </div>
            </template>
            <div style="padding:10px;">
                <div style="color:black;font-weight:bold;">全部品牌</div>
                <div>
                    <a href="#"
                        class="sidebar-subcate"
                        v-for="brand in filterBrandList"
                        :key="brand.brandUuid"
                        v-bind:class="{ selectcatefont : selectedMultiBrandList.includes(brand.brandUuid)}"
                        v-on:click="onSelectMultiBrand(brand.brandUuid)">
                        {{brand.brandName}}</a>
                </div>
            </div>
        </b-sidebar>
    </div>
</template>

<script>
import api from '@/api/api';
import search from '@/libs/search';
import { numberToFixed } from "@/libs/utils";
import "@/style/global.css";
export default {
    name: 'SalesList',
    data() {
        return {
            showSpin: false,
            isTableBusy: false,
            loadingInterval: 300,
            productFields: [
                { key: 'productImg', label: '缩图' },
                { key: 'productCode', label: '编码' },
                { key: 'productName', label: '品名', class: 'table-field-align-left' },
                { key: 'productSpec', label: '规格' },
                { key: 'mainCategoryName', label: '大类', class: 'table-field-align-left' },
                { key: 'subCategoryName', label: '小类', class: 'table-field-align-left' },
                { key: 'brandName', label: '品牌' },
                { key: 'unitName', label: '单位' },
                { key: 'packageName', label: '纸箱号' },
                { key: 'packageQuantity', label: '装箱量' },
                { key: 'warehouseProductStoreSalePeriod', label: '销售周期' },
                { key: 'entryedDate', label: '已售天数' },
                { key: 'displayPrice', label: '单价' },
                { key: 'warehouseProductStoreAmountFront', label: '现苗量' },
                { key: 'productIncreaseStepAmount', label: '订购单位' },
                { key: 'orderQuantity', label: '订购数量' },
                { key: 'orderButton', label: '操作' }
            ],
            prodcutItems: [],
            cartItems: [],
            selectedBand: null,
            feSearch: search.getSearchParams(),
            mainCateList: [],
            subCateList: [],
            filterSubCateList: [],
            brandList: [],
            filterBrandList: [],
            productSearchValue: '',
            selectedMultiCateList: [],
            isNeedUpdateBrand: false,
            selectedMultiBrandList: [],
            myfavoriteList: []
        };
    },
    mounted() {
        if (!this.checkMemberLogin()) {
            this.$router.push({
                name: 'MemberLogin'
            });
            return;
        };

        this.feSearch.filters.enable = true;

        //从商品详细页的跳转
        if (this.$route.query.productName) {
            this.feSearch.isFav = false;
            this.productSearchValue = this.$route.query.productName;
            let field = "CONCAT(productName, productCode)";
            search.globalRemoveFilterConditionKey(this.feSearch, field);
            this.feSearch.filters.conditions.push({
                name: field,
                type: 'like',
                value: this.productSearchValue
            });
        }

        this.getProductList();
        this.getSalesCartList();
        this.getSalesPageData();
        this.getMyFavorite();
    },
    methods: {
        numberToFixed,
        onResetMultiCate() {
            this.selectedMultiCateList = [];
            this.confirmMultiCateSearch();
        },
        onSelectMultiCate(cateUuid) {
            let index = this.selectedMultiCateList.indexOf(cateUuid);
            if (index === -1) {
                this.selectedMultiCateList.push(cateUuid);
            }
            else {
                this.selectedMultiCateList.splice(index, 1);
            }
        },
        confirmMultiCateSearch() {
            this.feSearch.isFav = false;
            search.globalRemoveFilterConditionKey(this.feSearch, 'productSubCategoryUuid');
            search.globalResetSearch(this.feSearch); //返回第一页
            if (this.selectedMultiCateList.length > 0) {
                this.feSearch.filters.conditions.push({
                    name: 'productSubCategoryUuid',
                    type: 'in',
                    value: JSON.stringify(this.selectedMultiCateList)
                });
            }
            this.isNeedUpdateBrand = true;
            //清除品牌选择信息
            search.globalRemoveFilterConditionKey(this.feSearch, 'productBrandUuid');
            this.selectedMultiBrandList = [];

            this.getProductList();
        },
        onResetMultiBrand() {
            this.selectedMultiBrandList = [];
            this.confirmMultiBrandSearch();
        },
        onSelectMultiBrand(brandUuid) {
            let index = this.selectedMultiBrandList.indexOf(brandUuid);
            if (index === -1) {
                this.selectedMultiBrandList.push(brandUuid);
            }
            else {
                this.selectedMultiBrandList.splice(index, 1);
            }
        },
        confirmMultiBrandSearch() {
            this.feSearch.isFav = false;
            search.globalRemoveFilterConditionKey(this.feSearch, 'productBrandUuid');
            search.globalResetSearch(this.feSearch); //返回第一页
            if (this.selectedMultiBrandList.length > 0) {
                this.feSearch.filters.conditions.push({
                    name: 'productBrandUuid',
                    type: 'in',
                    value: JSON.stringify(this.selectedMultiBrandList)
                });
            }
            this.getProductList();
        },
        addOrDelToFavorite(row) {
            let data = {
                productUuid: row.item.productUuid
            };
            if (this.myfavoriteList.includes(row.item.productUuid)) {
                this.showSpin = true;
                api.webDelProductFav(data).then(res => {
                    this.showSpin = false;
                    if (res.code === 0) {
                        this.getMyFavorite();
                    }
                });
            }
            else {
                this.showSpin = true;
                api.webAddProductFav(data).then(res => {
                    this.showSpin = false;
                    if (res.code === 0) {
                        this.getMyFavorite();
                    }
                });
            }
        },
        onShowMyfavorite() {
            this.feSearch.isFav = true;
            search.globalRemoveFilterConditionKey(this.feSearch, 'productSubCategoryUuid');
            search.globalRemoveFilterConditionKey(this.feSearch, 'productBrandUuid');
            search.globalRemoveFilterConditionKey(this.feSearch, 'productName');
            search.globalRemoveFilterConditionKey(this.feSearch, 'productUuid');
            this.feSearch.filters.conditions.push({
                name: 'productUuid',
                type: 'in',
                value: JSON.stringify(this.myfavoriteList)
            });
            search.globalPageOnChange(this.feSearch, 1);
            this.getProductList();
        },
        getMyFavorite() {
            // api.webGetMyFavProducts({}).then(res => {
            //     this.myfavoriteList = res.data.products;
            // });
        },
        getSalesPageData() {
            api.getSalesPageData({ saleType: 'curSale' }).then(res => {
                if (res.code === 0) {
                    this.mainCateList = res.data.mainCateList.records;
                    this.subCateList = res.data.subCateList.records;
                    this.subCateList.forEach(e => {
                        if (e.subCategoryFile) {
                            e.subCategoryFile = JSON.parse(e.subCategoryFile);
                            e.subCategoryFile.url = api.fileServer + e.subCategoryFile.url;
                        }
                    });
                    this.brandList = res.data.brandList.records;
                    this.filterBrandList = res.data.brandList.records;
                    this.brandList.forEach(e => {
                        if (e.brandMainImageFile) {
                            e.brandMainImageFile = JSON.parse(e.brandMainImageFile);
                            e.brandMainImageFile.url = api.fileServer + e.brandMainImageFile.url;
                        }
                    });
                }
            });
        },
        updateProductCartInfo() {
            if (this.prodcutItems.length > 0 && this.cartItems.length > 0) {
                this.prodcutItems.forEach(p => {
                    let cartItem = this.cartItems.find(c => {
                        return c.curSaleShoppingCartStoreUuid === p.warehouseProductStoreUuid;
                    });
                    if (cartItem) {
                        p.orderQuantity = cartItem.curSaleShoppingCartOrderQuantity;
                    }
                });
            }
        },
        getSalesCartList() {
            this.cartItems = [];
            setTimeout(() => {
                api.webCurrentSaleGetMyCart().then(res => {
                    if (res.code === 0) {
                        this.cartItems = res.data.cartItems.filter(e => {
                            return e.curSaleShoppingCartDistributionStationUuid === this.getStationUuid() && e.curSaleShoppingCartDistUuid === this.getAddressDistUuid();
                        });
                        this.updateProductCartInfo();
                    }
                });
            }, this.loadingInterval);
        },
        getProductList() {
            if (this.getAddressDistUuid() === '') {
                this.$bvModal.msgBoxOk("请选择种植地", {
                    title: "提示",
                    buttonSize: "sm",
                    size: "sm"
                });
                return;
            }
            if (this.getStationUuid() === '') {
                this.$bvModal.msgBoxOk("请选择配送站", {
                    title: "提示",
                    buttonSize: "sm",
                    size: "sm"
                });
                return;
            }
            this.feSearch.distUuid = this.getAddressDistUuid();
            this.feSearch.distributionStationUuid = this.getStationUuid();
            this.isTableBusy = true;
            setTimeout(() => {
                api.webCurSaleProductList(this.feSearch).then(res => {
                    this.isTableBusy = false;
                    if (res.code === 0) {
                        this.prodcutItems = res.data.records;
                        this.prodcutItems.forEach(p => {
                            if (p.productFinishImageFile) {
                                p.productFinishImageFile = JSON.parse(p.productFinishImageFile);
                                p.productFinishImageFile.url = api.fileServer + p.productFinishImageFile.url;
                            }
                            p.orderQuantity = 0;
                            p.warehouseProductStoreAmountFront = p.warehouseProductStoreAmountFront || 0;
                            p.warehouseProductStoreSalePeriod = p.warehouseProductStoreSalePeriod || p.productSalesPeriod;
                            this.updateProductCartInfo();
                        });
                        search.globalSetFilterRecordCount(this.feSearch, res.data.filterRecordCount);
                        if (this.isNeedUpdateBrand) {
                            this.isNeedUpdateBrand = false;
                            let brands = res.data.brands.map(e => {
                                return e.brandUuid;
                            });
                            this.filterBrandList = this.brandList.filter(e => {
                                return brands.includes(e.brandUuid);
                            });
                        }
                    }
                });
            }, this.loadingInterval);
        },
        searchProductByName() {
            this.feSearch.isFav = false;
            let field = "CONCAT(productName, productCode)";
            search.globalRemoveFilterConditionKey(this.feSearch, field);
            this.feSearch.filters.conditions.push({
                name: field,
                type: 'like',
                value: this.productSearchValue
            });
            this.getProductList();
        },
        //加入购物车
        addToCart(store) {
            if (store.orderQuantity % store.productIncreaseStepAmount !== 0) {
                this.$bvModal.msgBoxOk("订购数量必须是最小订购单位的整数倍", {
                    title: '提示',
                    buttonSize: 'sm'
                });
                return;
            }
            let data = {
                distributionStationUuid: this.getStationUuid(),
                distUuid: this.getAddressDistUuid(),
                storeUuid: store.warehouseProductStoreUuid,
                productUuid: store.warehouseProductStoreProductUuid,
                orderQuantity: store.orderQuantity
            };
            this.showSpin = true;
            api.webCurrentSaleAddToCart({ cartItems: [data] }).then(res => {
                if (res.code === 0) {
                    this.$bvModal.msgBoxOk("加入购物车成功", {
                        title: '提示',
                        buttonSize: 'sm'
                    });
                    this.getSalesCartList();
                }
                this.showSpin = false;
            });
        },
        goToCart() {
            let routeUrl = this.$router.push({
                path: '/member/cart-list',
                query: { tabIndex: 0 }
            });
        },
        onPageChange(pageNum) {
            search.globalPageOnChange(this.feSearch, pageNum);
            this.getProductList();
        }
    },
    components: {

    }
};
</script>

<style>
.table-field-align-left {
    text-align: left !important;
}
.selectcatefont {
    color: red !important;
}
.sidebar-subcate {
    margin-left: 20px;
    margin-bottom: 6px;
    word-break: keep-all;
    display: inline-block;
    text-decoration: none !important;
    color: grey;
}
.orderButton {
    margin-top: 20px;
    text-align: right;
}
.table-bordered td,
.table-bordered th {
    vertical-align: middle;
}

.col-lg-2,
.col-lg-3,
.col-lg-7 {
    padding-right: 0;
}

.selectcateborder {
    border: solid 2px red !important;
}

.card-img,
.card-img-top {
    height: 62px;
}

#sidebar-brand,#sidebar-cate{background-color:#fff !important;}
#sidebar-brand a:hover,#sidebar-cate a:hover{color:#1c9a5b;}
.b-sidebar > .b-sidebar-header{backgrond-color:#f7f7f7;}
.close:focus{outline: none;}
</style>



// WEBPACK FOOTER //
// src/view/sales/sales-list.vue